import React, { useEffect } from "react";
import "./App.css";

import { HashRouter, Routes, Route } from "react-router-dom";
import { GlobalProvider } from "./GlobalState/GlobalContext";
import { PermissionProvider } from "./GlobalState/PermissionContext";
import routeConstants from "./constants/routeConstants.json";
import Login from "./containers/Login";
import ForgotPassword from "./containers/ForgotPassword";
import Layout from "./components/Layout/Layout";
import RoleListPage from "./containers/RoleManagement/RolesList";
import RoleActivityPage from "./containers/RoleManagement/RoleActivityLog";
import AdminListPage from "./containers/AdminManagement/AdminList";
import NonAuthRouteProtection from "./containers/NonAuthRouteProtection";
import ProfileInfo from "./containers/ProfileManagement/ProfileInfoPage/";
import EditProfile from "./containers/ProfileManagement/EditProfile";
import ChangePassword from "./containers/ProfileManagement/ChangePassword/";
import AuthRouteProtection from "./containers/AuthRouteProtection";
import AddRoles from "./containers/RoleManagement/AddRoles";
import ViewRoleManagePage from "./containers/RoleManagement/ViewRole";
import EditRoles from "./containers/RoleManagement/EditRoles";
import AddAdminPage from "./containers/AdminManagement/AddAdmin";
import EditAdminPage from "./containers/AdminManagement/EditAdmin";
import ViewAdminManagePage from "./containers/AdminManagement/ViewAdmin";
import AdminActivityPage from "./containers/AdminManagement/AdminActivityLog";
import ResetPasswordPage from "./containers/Resetpassword";
import SetPasswordPage from "./containers/Setpassword";
import DashBoard from "./containers/DashBoard";
import TenantListPage from "./containers/TenantManagement/TenantList";
import AddTenantPage from "./containers/TenantManagement/AddTenant";
import EditTenantPage from "./containers/TenantManagement/EditTenant";
import TenantDetailsPage from "./containers/TenantManagement/TenantDetails";
import TenantActivityPage from "./containers/TenantManagement/TenantActivity";
import AddSubsrciptionPlan from "./containers/SubsrciptionPlan/AddPlan";
import EditSubsrciptionPlanPage from "./containers/SubsrciptionPlan/EditPlan";
import SubscriptionPlanList from "./containers/SubsrciptionPlan/ListPlan";
import SubscriptionPlanDetailsPage from "./containers/SubsrciptionPlan/PlanDetails";
import ProtectedRoute from "./containers/ProtectedRoute/ProtectedRoute";
import BackNavigationHandler from "./containers/BackNavigationHandler";

const App = () => {
  const tenantFeatureid = "67371df9534964294f80cfe4";
  const roleFeatureid = "66f50472b58f398ba8f04a8b";
  const adminFeatureid = "66f506fa5a192b6c70a82cd8";
  const planFeatureid = "67371d68534964294f80cfe3";
  const title = process.env.REACT_APP_APP_NAME;

  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <HashRouter>
      <BackNavigationHandler />

      <GlobalProvider>
        <Routes>
          <Route element={<NonAuthRouteProtection />}>
            <Route path={routeConstants.LOGIN} element={<Login />} />
            <Route
              path={routeConstants.FORGOT_PASSWORD}
              element={<ForgotPassword />}
            />
            <Route
              path={routeConstants.RESET_PASSWORD}
              element={<ResetPasswordPage />}
            />
            <Route
              path={routeConstants.SET_PASSWORD}
              element={<SetPasswordPage />}
            />
          </Route>
          <Route element={<PermissionProvider />}>
            <Route element={<AuthRouteProtection />}>
              <Route element={<Layout />}>
                <Route
                  path={routeConstants.ROLE_LIST}
                  element={
                    <ProtectedRoute
                      element={RoleListPage}
                      featureId={roleFeatureid}
                      action="view"
                    />
                  }
                />
                <Route
                  path={routeConstants.ADD_ROLE}
                  element={
                    <ProtectedRoute
                      element={AddRoles}
                      featureId={roleFeatureid}
                      action="add"
                    />
                  }
                />
                <Route
                  path={routeConstants.EDIT_ROLE}
                  element={
                    <ProtectedRoute
                      element={EditRoles}
                      featureId={roleFeatureid}
                      action="edit"
                    />
                  }
                />
                <Route
                  path={routeConstants.VIEW_ROLE}
                  element={
                    <ProtectedRoute
                      element={ViewRoleManagePage}
                      featureId={roleFeatureid}
                      action="view"
                    />
                  }
                />
                <Route
                  path={routeConstants.ACTIVITY_ROLE}
                  element={
                    <ProtectedRoute
                      element={RoleActivityPage}
                      featureId={roleFeatureid}
                      action="view"
                    />
                  }
                />
                <Route
                  path={routeConstants.DASHBOARD}
                  element={<DashBoard />}
                />
                <Route
                  path={routeConstants.VIEW_PROFILE}
                  element={<ProfileInfo />}
                />
                <Route
                  path={routeConstants.EDIT_PROFILE}
                  element={<EditProfile />}
                />
                <Route
                  path={routeConstants.CHANGE_PASSWORD}
                  element={<ChangePassword />}
                />
                <Route
                  path={routeConstants.ADMIN_LIST}
                  element={
                    <ProtectedRoute
                      element={AdminListPage}
                      featureId={adminFeatureid}
                      action="view"
                    />
                  }
                />
                <Route
                  path={routeConstants.ADD_ADMIN}
                  element={
                    <ProtectedRoute
                      element={AddAdminPage}
                      featureId={adminFeatureid}
                      action="add"
                    />
                  }
                />
                <Route
                  path={routeConstants.EDIT_ADMIN}
                  element={
                    <ProtectedRoute
                      element={EditAdminPage}
                      featureId={adminFeatureid}
                      action="edit"
                    />
                  }
                />
                <Route
                  path={routeConstants.VIEW_ADMIN}
                  element={
                    <ProtectedRoute
                      element={ViewAdminManagePage}
                      featureId={adminFeatureid}
                      action="view"
                    />
                  }
                />
                <Route
                  path={routeConstants.ACTIVITY_ADMIN}
                  element={
                    <ProtectedRoute
                      element={AdminActivityPage}
                      featureId={adminFeatureid}
                      action="view"
                    />
                  }
                />
                <Route
                  path={routeConstants.TENANT_LIST}
                  element={
                    <ProtectedRoute
                      element={TenantListPage}
                      featureId={tenantFeatureid}
                      action="view"
                    />
                  }
                />
                <Route
                  path={routeConstants.ADD_TENANT}
                  element={
                    <ProtectedRoute
                      element={AddTenantPage}
                      featureId={tenantFeatureid}
                      action="add"
                    />
                  }
                />
                <Route
                  path={routeConstants.EDIT_TENANT}
                  element={
                    <ProtectedRoute
                      element={EditTenantPage}
                      featureId={tenantFeatureid}
                      action="edit"
                    />
                  }
                />
                <Route
                  path={routeConstants.VIEW_TENANT}
                  element={
                    <ProtectedRoute
                      element={TenantDetailsPage}
                      featureId={tenantFeatureid}
                      action="view"
                    />
                  }
                />
                <Route
                  path={routeConstants.ACTIVITY_TENANT}
                  element={
                    <ProtectedRoute
                      element={TenantActivityPage}
                      featureId={tenantFeatureid}
                      action="view"
                    />
                  }
                />
                <Route
                  path={routeConstants.PLAN_DETAILS}
                  element={
                    <ProtectedRoute
                      element={SubscriptionPlanDetailsPage}
                      featureId={planFeatureid}
                      action="view"
                    />
                  }
                />
                <Route
                  path={routeConstants.ADD_PLAN}
                  element={
                    <ProtectedRoute
                      element={AddSubsrciptionPlan}
                      featureId={planFeatureid}
                      action="view"
                    />
                  }
                />
                <Route
                  path={routeConstants.EDIT_PLAN}
                  element={
                    <ProtectedRoute
                      element={EditSubsrciptionPlanPage}
                      featureId={planFeatureid}
                      action="view"
                    />
                  }
                />
                <Route />
                <Route
                  path={routeConstants.LIST_PLAN}
                  element={
                    <ProtectedRoute
                      element={SubscriptionPlanList}
                      featureId={planFeatureid}
                      action="view"
                    />
                  }
                />

                <Route />
              </Route>
            </Route>
          </Route>
        </Routes>
      </GlobalProvider>
    </HashRouter>
  );
};

export default App;
